<ion-modal [canDismiss]="false" (didDismiss)="isOpen = false">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-button mode="md" (click)="back()" *ngIf="state !== LoginModalState.Initial"><ion-icon mode="md"
              name="arrow-back-outline" aria-label="Back Button" style="color: white"></ion-icon></ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
          <ion-button mode="md" (click)="settings()"><ion-icon mode="md" name="information-circle-outline"
              aria-label="Settings Button" style="color: white"></ion-icon></ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content class="ion-padding">
      <ion-grid>
        <!-- Logo and tag -->
        <ion-row class="ion-justify-content-center">
          <ion-col size="10" sizeMd="3">
            <ion-img id="onco-ion-img" src="assets/onco-net.png" alt="ONCO NET Blue and Green Logo"></ion-img>
          </ion-col>
        </ion-row>
        <ion-row class="ion-justify-content-center">
          <ion-col size="10" sizeMd="3">
            <ion-row class="ion-justify-content-center">
              <ion-label style="font-style: italic">Oncology Navigation Empowerment for Treatment</ion-label>
            </ion-row>
          </ion-col>
        </ion-row>

        <!-- Initial form -->
        <div id="initialForm" *ngIf="state === LoginModalState.Initial">
          <ion-row class="ion-justify-content-center">
            <ion-col size="12" sizeMd="4">
              <ion-button id="loginButton" aria-label="Login Button" class="onco-primary-button"
                (click)="state = LoginModalState.ReturningUser" mode="md">
                Login
              </ion-button>
            </ion-col>
          </ion-row>
          <ion-row class="ion-margin-top ion-justify-content-center">
            <ion-col size="12" sizeMd="4">
              <ion-button id="signUpButton" aria-label="Sign Up Button" class="onco-secondary-button"
                (click)="state = LoginModalState.NewUser" mode="md">
                Sign Up
              </ion-button>
            </ion-col>
          </ion-row>

          <!-- Disabling Google Auth for now -->
          <!-- <ion-row class="ion-text-center ion-justify-content-center ion-margin-top"
            ><ion-col size="10" sizeMd="3">
              <hr />
            </ion-col>
          </ion-row>
          <ion-row class="ion-margin-top ion-justify-content-center">
            <ion-col size="12" sizeMd="4">
              <button class="gsi-material-button" (click)="openGoogleAuth()" type="button">
                <div class="gsi-material-button-state"></div>
                <div class="gsi-material-button-content-wrapper">
                  <div class="gsi-material-button-icon">
                    <svg
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 48 48"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      style="display: block"
                    >
                      <path
                        fill="#EA4335"
                        d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
                      ></path>
                      <path
                        fill="#4285F4"
                        d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
                      ></path>
                      <path
                        fill="#FBBC05"
                        d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
                      ></path>
                      <path
                        fill="#34A853"
                        d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
                      ></path>
                      <path fill="none" d="M0 0h48v48H0z"></path>
                    </svg>
                  </div>
                  <span class="gsi-material-button-contents">Continue with Google</span>
                  <span style="display: none">Continue with Google</span>
                </div>
              </button>
            </ion-col>
          </ion-row> -->
        </div>

        <!-- Sign up form -->
        <form id="newUserForm" *ngIf="state === LoginModalState.NewUser" [formGroup]="regForm"
          (ngSubmit)="submitRegistration()">
          <div>
            <ion-row class="ion-justify-content-center">
              <ion-col size="12" sizeMd="4">
                <ion-text>To get started, create an account by entering your email and choosing a password.
                  Alternatively, you
                  may sign up using your Google account.</ion-text>
              </ion-col>
            </ion-row>
            <ion-row class="ion-margin-top ion-justify-content-center">
              <ion-col size="12" sizeMd="4">
                <ion-input type="email" placeholder="Email" formControlName="email" email autocomplete="email"
                  inputmode="email" fill="solid" mode="md"></ion-input>
              </ion-col>
            </ion-row>
            <ion-row class="ion-justify-content-center">
              <ion-col size="12" sizeMd="4">
                <div>
                  <ng-container *ngFor="let validation of validations.email">
                    <div *ngIf="
                        regForm.get('email')!.hasError(validation.type) &&
                        (regForm.get('email')!.dirty || regForm.get('email')!.touched)
                      ">
                      <ion-icon class="error-text" name="information-circle-outline"></ion-icon>
                      <span class="error-text">{{ validation.message }}</span>
                    </div>
                  </ng-container>
                </div>
              </ion-col>
            </ion-row>
            <ion-row class="ion-justify-content-center">
              <ion-col size="12" sizeMd="4">
                <ion-input type="password" placeholder="Password" formControlName="password" password
                  autocomplete="new-password" fill="solid" mode="md"><ion-input-password-toggle color="primary"
                    slot="end"></ion-input-password-toggle></ion-input>
              </ion-col>
            </ion-row>
            <ion-row class="ion-justify-content-center">
              <ion-col size="12" sizeMd="4">
                <div>
                  <ng-container *ngFor="let validation of validations.password">
                    <div class="error-message" *ngIf="
                        regForm.get('password')!.hasError(validation.type) &&
                        (regForm.get('password')!.dirty || regForm.get('password')!.touched)
                      ">
                      <ion-icon class="error-text" name="information-circle-outline"></ion-icon>
                      <span class="error-text">{{ validation.message }}</span>
                    </div>
                  </ng-container>
                </div>
              </ion-col>
            </ion-row>
            <ion-row class="ion-justify-content-center">
              <ion-col size="12" sizeMd="4">
                <ion-input type="password" placeholder="Confirm Password" formControlName="confirm_password" password
                  autocomplete="new-password" fill="solid" mode="md"><ion-input-password-toggle slot="end"
                    color="primary"></ion-input-password-toggle></ion-input>
              </ion-col>
            </ion-row>
            <ion-row class="ion-justify-content-center">
              <ion-col size="12" sizeMd="4">
                <div>
                  <ng-container *ngFor="let validation of validations.confirm_password">
                    <!-- Don't show password confirmation errors until the password passes checks -->
                    <div class="error-message" *ngIf="
                        regForm.get('confirm_password')!.hasError(validation.type) &&
                        !regForm.get('password')!.hasError(validation.type) &&
                        (regForm.get('confirm_password')!.dirty || regForm.get('confirm_password')!.touched)
                      ">
                      <ion-icon class="error-text" name="information-circle-outline"></ion-icon>
                      <span class="error-text">{{ validation.message }}</span>
                    </div>
                  </ng-container>
                </div>
              </ion-col>
            </ion-row>
            <!-- <ion-row class="ion-margin-top ion-justify-content-center">
              <ion-col size="12" sizeMd="4">
                <ion-checkbox class="onco-checkbox" labelPlacement="end" justify="start" formControlName="terms">
                  I agree to the
                  <ion-text href="/tos" (click)="$event.stopPropagation()">terms and conditions.</ion-text>
                </ion-checkbox>
              </ion-col>
            </ion-row> -->
            <ion-row class="ion-margin-top ion-justify-content-center">
              <ion-col size="12" sizeMd="4">
                <ion-button id="signUpButton" aria-label="Sign Up Button" class="onco-primary-button" type="submit"
                  fill="outline" [disabled]="signinDisabled || !regForm.valid" mode="md">Sign Up</ion-button>
              </ion-col>
            </ion-row>
          </div>
        </form>

        <!-- Login form -->
        <form id="returningUserForm" *ngIf="state === LoginModalState.ReturningUser" [formGroup]="loginForm"
          (ngSubmit)="submitLogin()">
          <ion-row class="ion-justify-content-center">
            <ion-col size="12" sizeMd="4">
              <ion-text>Sign in with your existing account or use Google to log in.</ion-text>
            </ion-col>
          </ion-row>
          <ion-row class="ion-margin-top ion-justify-content-center">
            <ion-col size="12" sizeMd="4">
              <ion-input type="email" formControlName="email" email autocomplete="email" inputmode="email"
                placeholder="Email" fill="solid" mode="md" appAutofill></ion-input>
            </ion-col>
          </ion-row>
          <ion-row class="ion-justify-content-center">
            <ion-col size="12" sizeMd="4">
              <div>
                <ng-container *ngFor="let validation of validations.email">
                  <div *ngIf="
                      loginForm.get('email')!.hasError(validation.type) &&
                      (loginForm.get('email')!.dirty || loginForm.get('email')!.touched)
                    ">
                    <ion-icon class="error-text" name="information-circle-outline"></ion-icon>
                    <span class="error-text">{{ validation.message }}</span>
                  </div>
                </ng-container>
              </div>
            </ion-col>
          </ion-row>
          <ion-row class="ion-justify-content-center">
            <ion-col size="12" sizeMd="4">
              <ion-input type="password" formControlName="password" placeholder="Password" password
                autocomplete="current-password" fill="solid" mode="md" appAutofill>
                <ion-input-password-toggle slot="end" color="primary"></ion-input-password-toggle>
              </ion-input>
            </ion-col>
          </ion-row>
          <ion-row class="ion-justify-content-center">
            <ion-col size="12" sizeMd="4">
              <div>
                <ng-container *ngFor="let validation of validations.password">
                  <div *ngIf="
                      loginForm.get('password')!.hasError(validation.type) &&
                      (loginForm.get('password')!.dirty || loginForm.get('password')!.touched)
                    ">
                    <ion-icon class="error-text" name="information-circle-outline"></ion-icon>
                    <span class="error-text">{{ validation.message }}</span>
                  </div>
                </ng-container>
              </div>
            </ion-col>
          </ion-row>
          <ion-row class="ion-text-right">
            <ion-col size="12" sizeMd="8">
              <ion-text (click)="state = LoginModalState.ForgotPassword" class="forgot-password">Forgot
                Password</ion-text>
            </ion-col>
          </ion-row>
          <ion-row class="ion-justify-content-center">
            <ion-col size="12" sizeMd="4">
              <ion-button id="signInButton" aria-label="Sign In Button" class="onco-primary-button" type="submit"
                [disabled]="signinDisabled || !loginForm.valid" mode="md">Sign In</ion-button>
            </ion-col>
          </ion-row>
        </form>

        <!-- Forgot password form -->
        <form id="forgotPasswordForm" *ngIf="state === LoginModalState.ForgotPassword" [formGroup]="forgotPasswordForm"
          (ngSubmit)="submitForgotPassword()">
          <ion-row class="ion-justify-content-center">
            <ion-col size="12" sizeMd="4">
              <ion-text>Enter your email to send a password reset link.</ion-text>
            </ion-col>
          </ion-row>
          <ion-row class="ion-margin-top ion-justify-content-center">
            <ion-col size="12" sizeMd="4">
              <ion-input type="email" placeholder="Email" formControlName="email" email autocomplete="email"
                inputmode="email" fill="solid" mode="md"></ion-input>
            </ion-col>
          </ion-row>
          <ion-row class="ion-justify-content-center">
            <ion-col size="12" sizeMd="4">
              <div>
                <ng-container *ngFor="let validation of validations.email">
                  <div *ngIf="
                      forgotPasswordForm.get('email')!.hasError(validation.type) &&
                      (forgotPasswordForm.get('email')!.dirty || forgotPasswordForm.get('email')!.touched)
                    ">
                    <ion-icon class="error-text" name="information-circle-outline"></ion-icon>
                    <span class="error-text">{{ validation.message }}</span>
                  </div>
                </ng-container>
              </div>
            </ion-col>
          </ion-row>
          <ion-row class="ion-margin-top ion-justify-content-center">
            <ion-col size="12" sizeMd="4">
              <ion-button id="sendResetButton" aria-label="Reset Password Button" class="onco-primary-button"
                type="submit" expand="block" fill="outline"
                [disabled]="signinDisabled || !forgotPasswordForm.valid">Send Password Reset Email</ion-button>
            </ion-col>
          </ion-row>
        </form>

        <!-- Reset password form -->
        <form id="resetPasswordForm" *ngIf="state === LoginModalState.ResetPassword" [formGroup]="resetPasswordForm"
          (ngSubmit)="submitResetPassword()">

          <ion-row class="ion-justify-content-center">
            <ion-col size="12" sizeMd="4">
              <ion-text>You need to make a new password.</ion-text>
            </ion-col>
          </ion-row>

          <ion-row class="ion-justify-content-center">
            <ion-col size="12" sizeMd="4">
              <ion-input type="password" placeholder="New Password" formControlName="password" password
                autocomplete="new-password" fill="solid" mode="md"><ion-input-password-toggle
                  slot="end"></ion-input-password-toggle>
              </ion-input>
            </ion-col>
          </ion-row>

          <ion-row class="ion-justify-content-center">
            <ion-col size="12" sizeMd="4">
              <div class="error-container">
                <ng-container *ngFor="let validation of validations.password">
                  <div class="error-message" *ngIf="
                                resetPasswordForm.get('password')!.hasError(validation.type) &&
                                (resetPasswordForm.get('password')!.dirty || resetPasswordForm.get('password')!.touched)
                              ">
                    <ion-icon name="information-circle-outline"></ion-icon>
                    <span>{{ validation.message }}</span>
                  </div>
                </ng-container>
              </div>
            </ion-col>
          </ion-row>

          <ion-row class="ion-justify-content-center">
            <ion-col size="12" sizeMd="4">
              <ion-button type="submit" aria-label="Reset Password Button" expand="block" fill="outline"
                [disabled]="signinDisabled || !resetPasswordForm.valid">Reset Password</ion-button>
            </ion-col>
          </ion-row>

        </form>
      </ion-grid>
    </ion-content>

    <ion-footer *ngIf="!nav.isKeyboardOnscreen">
      <ion-img id="kucc-ion-img" src="assets/kucc.png" alt="Blue University of Kansas Cancer Center Logo"></ion-img>
    </ion-footer>
  </ng-template>
</ion-modal>